module.exports = __webpack_public_path__ + "img/logo.0f561364.png";